import styled from "styled-components"

import { colors, spacing } from "@minuthq/meatball-ui-react"

import { breakpoint } from "src/constants/breakpoints"
import { MCard } from "src/ui/MCard/MCard"

export const IntegrationStatusContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${spacing.L};
  > :first-child {
    border-bottom: 1px solid ${colors.divider};
  }

  @container (${breakpoint.mediumUp}) {
    grid-template-columns: repeat(2, 1fr);
    > :first-child {
      border-right: 1px solid ${colors.divider};
      border-bottom: none;
    }
  }
`

export const IntegrationStatusSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.M};
`
export const CircularProgressWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

export const StyledMCard = styled(MCard)`
  display: grid;
  gap: ${spacing.M};
`
export const LinkedIntegrationsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS};
`
